import {withTranslation} from "react-i18next";
import TextField from "@material-ui/core/TextField/TextField";
import Button from "react-bootstrap/Button";
import {Link} from "react-router-dom";
import React, {PureComponent} from "react";
import Connect from "react-redux/es/connect/connect";
import {getSchools, login} from "../../../actions";
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Loading from '../../subComponents/GenericLoading/loading';
import {
    dispatchOnLogin,
    dispatchOnLoginFailure,
    dispatchOnLoginGetSchools,
    dispatchOnLoginGetSchoolsFailure,
    dispatchOnLoginGetSchoolsSuccess,
    dispatchOnLoginSuccess
} from "../functions";
import '../../../App.css'
import '../../../index.css'
import {debug} from "../../../utility/functions";

class LoginContainer extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            username:"",
            password: "",
            school: -1,
            userType: 0,
            classLogging: false
        };
    }

    componentDidMount() {
        this.onGetSchools()
    }

    onLogin = (postData) => {
        this.props.dispatchOnLogin();
        login(postData)
            .then((response) => {
                debug(" Login success -> ", response);
                this.props.dispatchOnLoginSuccess(response);
            })
            .catch((error) => {
                debug(" Login error -> ", error);
                this.props.dispatchOnLoginFailure();
            })
    };

    onGetSchools = () => {
        this.props.dispatchOnLoginGetSchools();
        getSchools()
            .then((response) => {
                this.props.dispatchOnLoginGetSchoolsSuccess(response);
            })
            .catch((response) => {
                this.props.dispatchOnLoginGetSchoolsFailure();
            })
    };

    onSubmitClass = (e) =>  {
        e.preventDefault();

        const post = {
            username: this.state.username,
            password: this.state.password
        };

        if(this.state.userType === 1) {
            post.school = this.state.school;
        }

        this.onLogin(post);
    };

    onChange = (e) =>  {
        this.setState({[e.target.name]: e.target.value});
    };

    handleChange = (event) =>  {
        this.setState({[event.target.name]: event.target.value});
    };

    getSchool = (id) => {
        const {schools} = this.props;
        if(schools){
            return schools.filter(function (item) {return item.id === id}).map((item) => (item))[0]
        }
    };

    renderDefaultValue(context, value){
        if(value === -1) {
            return "Selecione a escola"
        }
        return this.getSchool(value).name
    }

    renderSchoolOptions(){
        const {schools} = this.props;

        if(schools) {
            return schools.map((e) => <MenuItem key={e.name} value={e.id}>{e.name}</MenuItem>)
        }
    }

    renderSchoolsSelectInput(){
        const {userType} = this.state;
        if(userType === 1 || userType === "1") {
            return(
                <FormControl required className="MuiFormControl-marginNormal login-container-screen-actions-container-login-text-field">
                    <InputLabel htmlFor="school-required">Escola</InputLabel>
                    <Select
                        value={this.state.school}
                        onChange={this.handleChange}
                        name="school"
                        displayEmpty={true}
                        inputProps={{
                            id: 'school-required',
                        }}
                        renderValue={(e) => this.renderDefaultValue(this, e)}
                        className='login-container-screen-actions-container-login-text-field'
                    >
                        {this.renderSchoolOptions()}
                    </Select>
                </FormControl>
            )
        }
    }

    render() {
        const {t, loading} = this.props;
        const {username, password} = this.state;
        return (
            <div className="login-container-screen-actions-container-login-form">
                <form autoComplete="off" onSubmit={this.onSubmitClass} >
                    <FormControl required className="MuiFormControl-marginNormal login-container-screen-actions-container-login-text-field">
                        <InputLabel htmlFor="age-required">Escolha o tipo de utilizador</InputLabel>
                        <Select
                            value={this.state.userType}
                            onChange={this.handleChange}
                            name="userType"
                            displayEmpty={true}
                            inputProps={{
                                id: 'age-required',
                            }}
                            className='login-container-screen-actions-container-login-text-field'
                        >
                            <MenuItem key={0} value={0}>Coordenador Escolar</MenuItem>
                            <MenuItem key={1} value={1}>Turma</MenuItem>
                        </Select>
                    </FormControl>
                    {this.renderSchoolsSelectInput()}
                    <TextField
                        id="login-username"
                        label={t('Username')}
                        name="username"
                        className="login-container-screen-actions-container-login-text-field"
                        value={username}
                        margin="normal"
                        required
                        onChange={this.onChange}
                    />
                    <TextField
                        id="login-password"
                        label={t('Password')}
                        name="password"
                        type="password"
                        className="login-container-screen-actions-container-login-text-field"
                        defaultValue={password}
                        margin="normal"
                        required
                        onChange={this.onChange}
                    />
                    <div className='login-container-screen-actions-container'>
                        <Button className="login-container-screen-actions-container-login-button" type="submit">{loading?<Loading size={"small-spinner"} color={"white"}/>:t('Login')}</Button>

                        <div className="login-container-screen-actions-container-login-recovery-action">
                            <Link to="/recovery-password">{t('Recovery password?')}</Link>
                        </div>
                    </div>
                </form>

            </div>
        );
    }
}

const mapStateToProps = store => ({
    schools: store.loginReducer.schools,
    loading: store.loginReducer.loading
});

const mapFunctionsToProps = {
    dispatchOnLogin,
    dispatchOnLoginSuccess,
    dispatchOnLoginFailure,
    dispatchOnLoginGetSchools,
    dispatchOnLoginGetSchoolsSuccess,
    dispatchOnLoginGetSchoolsFailure,
};

export default (Connect(mapStateToProps, mapFunctionsToProps)(withTranslation("translations")(LoginContainer)));
